/**
 * Generato automaticamente.
 * framework-cfg-utenti
 */

export type WsEsternoParametroServizioTipo =
  (typeof WsEsternoParametroServizioTipo)[keyof typeof WsEsternoParametroServizioTipo];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WsEsternoParametroServizioTipo = {
  STRING: 'STRING',
  NUMBER: 'NUMBER',
  BOOLEAN: 'BOOLEAN',
  DATE: 'DATE',
} as const;
